import React from 'react'
import ExcelCard from '../components/ExcelCard'

function TestPage() {
    return (
        <ExcelCard name={"excel.excel"} url={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSoyDp54IEfhfn0eL4d2V6Iu08k5wMnajRzdpNG1Z3J&s"} date={"2022-10-10"}/>
    )
}

export default TestPage
